import React, { useEffect } from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSelectedCategory, useSelectedThemeColor, useSetSelectedThemeColor } from '../../../store/appStore';
import { THEME_KEYS } from '@common/constants/themes';
import { TemplateGrid } from '../components/TemplateGrid/TemplateGrid';

export function TemplateSelection() {
  const { t } = useTranslation();
  const selectedCategory = useSelectedCategory();
  const selectedThemeColor = useSelectedThemeColor();
  const setSelectedThemeColor = useSetSelectedThemeColor();

  useEffect(() => {
    if (!selectedThemeColor) {
      setSelectedThemeColor(THEME_KEYS.RECOMMENDED);
    }
  }, [selectedThemeColor, setSelectedThemeColor]);

  if (!selectedCategory) {
    return null;
  }

  return (
    <Box direction="vertical" height="100%" width="100%" gap={2}>
      <Box direction="vertical" height="100%" gap={3}>
        <Box direction="vertical" gap={1}>
          <Heading size="medium">{t('template_select.header.title')}</Heading>

          <Text>{t('template_select.header.subtitle')}</Text>
        </Box>

        <TemplateGrid />
      </Box>
    </Box>
  );
}
